import { IRootState } from '..'

export const getLot = (state: IRootState, id: string) =>
  state.lotState.lots.filter(lot => lot.id === id)[0]
